module.exports = __webpack_public_path__ + "img/Argentina.f461f12e.gif";